<template>
  <div class="orderSuccess">
    <div v-if="orderPaymentStatus && orderState">
      <div
        class="order-success"
        v-if="
          orderPaymentStatus == 'PAYMENT_SUCCESSFUL' ||
          (orderState == 'CONFIRMED' &&
            orderPaymentStatus != 'PAYMENT_FAILURE') ||
          orderState == 'GROUP_PURCHASE_ORDER_PLACED'
        "
      >
        <div class="confirmed-order">
          <div class="cngrts-wrapr">
            <img src="../../assets/images/order-success/congrats.png" />
            <p class="cngrts-text">We have received your order.</p>
          </div>
        </div>
        <div class="order-qr-detail">
          <div
            class="qr-wrapper"
            v-for="(itemDetail, index) in orderDetails"
            :key="index"
          >
            <div
              class="item-qr-card"
              style="display: none;"
            >
              <p class="qr-img-wrapr">
                <img
                  :src="itemDetail.qrCode"
                  alt="product-image"
                  class="order-qr-image"
                  @click="openDialogue(index)"
                />
              </p>
              <div
                class="openDialogue"
                v-if="isShow === index"
              >
                <div
                  class="zoom-image"
                  style="text-align: center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 23 23"
                    @click="isShow = !isShow"
                  >
                    <path
                      fill="#CDCDCD"
                      fill-rule="nonzero"
                      d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                      opacity=".675"
                    />
                  </svg>
                  <img
                    :src="itemDetail.qrCode"
                    v-if="itemDetail.qrCode"
                  />
                  <p
                    style="color: white; font-size: 1.25em"
                    v-else
                  >
                    NO QR Code Available
                  </p>
                </div>
              </div>
              <div
                class="item-detail"
                v-if="
                  itemDetail.subOrderDTOList[0] &&
                  !itemDetail.subOrderDTOList[0].sellerLiteDTO.isGlobalShop
                "
              >
                <p class="name">
                  <strong>{{
                    itemDetail.subOrderDTOList[0].sellerLiteDTO.storeName
                  }}</strong>
                </p>
                <p class="mobile">
                  <Call-icon /> :
                  <strong>{{
                    itemDetail.subOrderDTOList[0].sellerLiteDTO.phone
                  }}</strong>
                </p>
                <p class="location">
                  <span
                    class="material-icons"
                    style="font-size: 1.25em"
                  >location_on</span>
                  {{
                    itemDetail.subOrderDTOList[0].sellerLiteDTO
                      .sellerShopAddress.address
                  }},{{
                    itemDetail.subOrderDTOList[0].sellerLiteDTO
                      .sellerShopAddress.city
                  }},{{
                    itemDetail.subOrderDTOList[0].sellerLiteDTO
                      .sellerShopAddress.zipCode
                  }}
                </p>
              </div>
              <div
                class="item-detail"
                v-else
              >
                <p class="name">
                  <strong>We will shortly inform you, from where you have to collect
                    your item</strong>
                </p>
              </div>
            </div>
            <div class="price-detail">
              <div class="total-item">
                Total Item: <strong>{{ itemDetail.totalItems }}</strong>
              </div>
              <div class="total-item">
                Total Price: <strong>{{ itemDetail.totalPaidAmount }}</strong>
              </div>
            </div>
            <div
              class="shareCashback-popup"
              v-if="showCashBackPopUp && cashBackAmount"
              style="display: none;"
            >
              <div class="sharecashback-wrpr">
                <div
                  class="share-karein"
                  v-if="$cookie.get('version-code') > 100"
                >
                  <div
                    class="new-Share-Text"
                    v-if="sharedCashBack"
                  >
                    <figure class="img-wrapper">
                      <img
                        src="../../assets/images/order-success/medal.svg"
                        style="height: 170px"
                      />
                    </figure>
                    <p class="share-text txtCenter">Thank You</p>
                    <p class="cashbck-amnt txtCenter">
                      {{ $t("sharedCashBackMessage") }}
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 23 23"
                      @click="showCashBackPopUp = !showCashBackPopUp"
                      class="close-pop-up"
                    >
                      <path
                        fill="#CDCDCD"
                        fill-rule="nonzero"
                        d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                        opacity=".675"
                      />
                    </svg>
                  </div>
                  <div
                    class="new-Share-Text"
                    v-else
                  >
                    <figure class="img-wrapper">
                      <img src="../../assets/images/order-success/blick-cashback.gif" />
                    </figure>
                    <p class="share-text">{{ $t("shareAndEarn") }}</p>
                    <div v-if="notSharedOnWhatsapp">
                      <p class="cashbck-amnt">{{ $t("couponNotSHared") }}</p>
                    </div>
                    <div v-else>
                      <p class="cashbck-amnt">1. {{ $t("offerList1") }}</p>
                      <p class="cashbck-amnt">
                        2.
                        {{
                          $t("offerList2", { cashBackAmount: cashBackAmount })
                        }}
                      </p>
                    </div>
                    <p
                      class="share-btn-wrpr"
                      @click="
                        shareBasketItem(
                          itemDetail.subOrderDTOList[0].itemImage,
                          itemDetail.subOrderDTOList[0]
                            .sellerItemRelationShipId,
                          orderDetails[0].subOrderDTOList[0].subOrderId,
                          itemDetail.subOrderDTOList[0].sellerLiteDTO.shopId
                        )
                      "
                      v-if="
                        itemDetail.subOrderDTOList[0] &&
                        cashBackAmount &&
                        !sharedCashBack
                      "
                    >
                      <img src="../../assets/images/order-success/btn-share.gif" />
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 23 23"
                      @click="showCashBackPopUp = !showCashBackPopUp"
                      class="close-pop-up"
                    >
                      <path
                        fill="#CDCDCD"
                        fill-rule="nonzero"
                        d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                        opacity=".675"
                      />
                    </svg>
                  </div>
                </div>
                <div
                  class="share-karein"
                  v-else
                >
                  <figure class="img-wrapper">
                    <img src="../../assets/images/order-success/blick-cashback.gif" />
                  </figure>
                  <p class="share-text">Share and Get Cashback</p>
                  <p class="cashbck-amnt">
                    2 दोस्तों की खरीद पूरी होते ही कैशबैक पाओ
                  </p>
                  <p
                    class="share-btn-wrpr"
                    @click="
                      shareBasketItem(
                        itemDetail.subOrderDTOList[0].itemImage,
                        itemDetail.subOrderDTOList[0].sellerItemRelationShipId,
                        orderDetails[0].subOrderDTOList[0].subOrderId,
                        itemDetail.subOrderDTOList[0].sellerLiteDTO.shopId
                      )
                    "
                    v-if="itemDetail.subOrderDTOList[0] && cashBackAmount"
                  >
                    <img src="../../assets/images/order-success/btn-share.gif" />
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 23 23"
                    @click="showCashBackPopUp = !showCashBackPopUp"
                    class="close-pop-up"
                  >
                    <path
                      fill="#CDCDCD"
                      fill-rule="nonzero"
                      d="M19.636 3.364C15.15-1.12 7.85-1.122 3.364 3.364c-4.486 4.487-4.485 11.785 0 16.271 4.486 4.487 11.785 4.487 16.272 0 4.485-4.486 4.485-11.785 0-16.27zm-3.599 12.673a.885.885 0 0 1-1.251 0L11.5 12.75l-3.442 3.442a.885.885 0 1 1-1.251-1.251l3.442-3.442-3.286-3.286a.885.885 0 1 1 1.251-1.251l3.286 3.286 3.13-3.13a.885.885 0 1 1 1.25 1.252L12.753 11.5l3.285 3.286a.885.885 0 0 1 0 1.25z"
                      opacity=".675"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            class="cashBack-note"
            v-if="$cookie.get('version-code') > 100 && !sharedCashBack"
            style="display: none;"
          >
            <h4>{{ $t("shareAndEarn") }}</h4>
            <ul v-if="notSharedOnWhatsapp">
              <li>{{ $("couponNotSHared") }}</li>
            </ul>
            <ul v-else>
              <li>1. {{ $t("offerList1") }}</li>
              <li>
                2. {{ $t("offerList2", { cashBackAmount: cashBackAmount }) }}
              </li>
            </ul>
          </div>
          <div
            class="cashBack-note"
            v-if="$cookie.get('version-code') > 100 && sharedCashBack"
            style="display: none;"
          >
            <ul>
              <li style="color: green">{{ $t("sharedCashBackMessage") }}</li>
            </ul>
          </div>
        </div>
        <div
          class="cashback-share"
          v-if="cashBackAmount && $cookie.get('version-code')"
          @click="openCashbackPopUp()"
          style="display: none;"
        >
          <img src="../../assets/images/order-success/share-cashback.gif" />
        </div>

        <div class="order-product-dtl">
          <div class="item-img-box">
            <img :src="orderDetails[0].subOrderDTOList[0].itemImage" />
          </div>

          <div class="product-col-info">
            <h2>{{orderDetails[0].subOrderDTOList[0].itemName}} </h2>
            <div
              class="product-attribute"
              v-for="attributeItem in orderDetails[0].subOrderDTOList[0].itemAttributeDTOs"
              :key="index"
            >
              <span class="attribute-title">{{attributeItem.itemAttributeName}} : </span>
              <span class="attribute-value">{{attributeItem.itemAttributeValue}}</span>

            </div>
          </div>

        </div>

        <div class="goto-btn-blk">
          <span
            class="go-to-order"
            @click="goToListing()"
          >आर्डर पेज पर जाए।</span>
        </div>

      </div>

      <div
        class="page-status-panel"
        v-else-if="
          orderPaymentStatus && orderPaymentStatus == 'PAYMENT_FAILURE'
        "
      >
        <div class="img-block">
          <img
            src="../../assets/images/icons/payment-failed.svg"
            alt="payment-failed"
          />
        </div>
        <div class="details-block">
          <h2>{{ $t("paymentFailed") }}</h2>
          <p>
            <span>{{ $t("paymentFailedMessage") }}</span>
          </p>
        </div>
        <div class="btn-block">
          <router-link
            tag="span"
            :to="{ path: '/product-deal' }"
            class="gotohome"
            replace
          >{{ $t("goToHome") }}</router-link>
        </div>
      </div>

      <div
        class="page-status-panel"
        v-else-if="
          orderPaymentStatus && orderPaymentStatus == 'VERIFICATION_FAILED'
        "
      >
        <div class="img-block">
          <img
            src="../../assets/images/icons/payment-failed.svg"
            alt="payment-failed"
          />
        </div>
        <div class="details-block">
          <h2>Payment Under Verification</h2>
          <p>
            <span>Your payment is under verification state.</span>
          </p>
        </div>
        <div class="btn-block">
          <router-link
            tag="span"
            :to="{ path: '/' }"
            class="gotohome"
            replace
          >Go to Home</router-link>
        </div>
      </div>

      <div
        class="page-status-panel"
        v-else-if="
          orderPaymentStatus &&
          (orderPaymentStatus === 'GATEWAY_PENDING' ||
            orderPaymentStatus === 'PAYMENT_PENDING')
        "
      >
        <div class="img-block">
          <img
            src="../../assets/images/waitingIcon.gif"
            alt="payment-failed"
          />
        </div>
        <div class="details-block">
          <h2>Payment Pending</h2>
          <p>
            <span>Your Payment is in Pending State.</span>
          </p>
        </div>
        <div class="btn-block">
          <router-link
            tag="span"
            :to="{ path: '/' }"
            class="gotohome"
            replace
          >Go to Home</router-link>
        </div>
      </div>
    </div>

    <div
      class="loader"
      v-if="loading"
    >
      <img
        src="../../assets/images/loader.gif"
        alt="loader"
      />
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
import "../../assets/css/product-detail.scss";
import CallIcon from "@/components/Icons/CallIcon";
import store from "../../store/store";
import ApiCaller from "../../utils/apicaller";
import "../../assets/css/order-confirm.scss";
import { replcePhoneWithAsterik } from "../../utils/helper";
export default {
  name: "orderSuccess",
  data() {
    return {
      orderDetails: [],
      orderPaymentStatus: "",
      orderState: "",
      addressDTO: {},
      subOrderDto: [],
      orderStatus: {},
      loading: false,
      confirmation: false,
      cartOrderDetails: [],
      cartOrderState: {},
      isShow: false,
      shareBasketList: [],
      basketId: 0,
      cashBackAmount: null,
      showCashBackPopUp: false,
      sharedCashBack: false,
      notSharedOnWhatsapp: false,
    };
  },
  components: {
    CallIcon,
  },
  methods: {
    replcePhoneWithAsterik,
    openDialogue(index) {
      this.isShow = index;
    },
    openCashbackPopUp() {
      try {
        JSBridgePlugin.fireEvents("CLICK_CASHBACK_SHARE_BUTTON");
      } catch (err) {
        console.log(err);
      }
      this.showCashBackPopUp = !this.showCashBackPopUp;
    },
    goToListing() {
      let id = 137;
      let applicationUrl = "https://mall91.com/#/order-history";
      let appName = "mall91";
      let iconImageUrl =
        "https://cdn.mall91.com/adeb3918-d492-43ed-86a6-ae4140ce05ec_original.jpg";
      try {
        JSBridgePlugin.openMiniApp(
          Number(id),
          applicationUrl,
          appName,
          iconImageUrl
        );
      } catch (err) {
        window.open("https://mall91.com/#/order-history");
      }
      this.$store.commit("saveGroupPerchaseOrder", {
        orderId: this.$route.params.orderId,
      });
    },
    shareBasketItem(itemImage, sellerItemId, subOrderId, shopId) {
      try {
        JSBridgePlugin.fireEvents("CLICK_ON_POPUP_CASHBACK_SHARE");
      } catch (err) {
        console.log(err);
      }
      const basketInfo = this.shareBasketList.find(
        (basket) => basket.shopId === shopId
      );
      if (basketInfo === void 0) {
        console.log("no basket found");
        return;
      }
      this.loading = true;
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        `get-share-details/${sellerItemId}?type=BASKET_GROUP_SHARING&referenceId=${subOrderId}&basketGroupId=${basketInfo.basketGroupId}`,
        "get"
      )
        .then((data) => {
          this.loading = false;
          const obj = {
            message: data.data.shareMessage,
            imageUrl: itemImage,
            isStatusShare: true,
          };
          if (this.$cookie.get("version-code") > 100) {
            obj.callback = "_getShare.share";
            _getShare.share = (res) => {
              if (res === "success") {
                this.sharedCashBack = true;
                try {
                  JSBridgePlugin.fireEvents("CASHBACK_SHARED_ON_WHATSAPP");
                } catch (err) {
                  console.log(err);
                }
                this.addUserCoupon();
              } else {
                // this.notSharedOnWhatsapp = true
              }
            };
          }
          try {
            JSBridgePlugin.share(JSON.stringify(obj));
          } catch (err) {
            console.log(err);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    addUserCoupon() {
      const obj = {
        orderId: this.orderDetails[0].orderId,
        applicationId: 200,
      };
      ApiCaller(constant.COUPON_API_URL, "add/user/coupon", "post", obj)
        .then((data) => {})
        .catch((err) => {
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = (res) => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.addUserCoupon();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          } else if (
            err.response.data.errorCodes[0] == "COUPON_LIMIT_EXCEEDED"
          ) {
            this.loading = false;
            // this.toasterData = {
            //   msg: '',
            //   color: "#E51C24",
            //   iconName: "close"
            // };
            // this.isToasterData = true;
          }
        });
    },
    getOrdersByOrderMasterId() {
      this.loading = true;
      ApiCaller(
        constant.LOCAL_SHOP_URL_ORDER,
        "get-order-by-master-order-id/" + this.$route.params.orderId,
        "get"
      )
        .then((data) => {
          this.orderDetails = data.data;
          if (data.data[0]) {
            this.orderPaymentStatus = data.data[0].orderPaymentStatus;
            this.orderState = data.data[0].orderState;
          }

          this.loading = false;
          if (
            (this.orderDetails &&
              this.orderDetails.length &&
              this.orderDetails[0].orderState == "PAYMENT_SUCCESSFUL") ||
            (this.orderDetails &&
              this.orderDetails.length &&
              this.orderDetails[0].orderState == "CONFIRMED" &&
              this.$store.getters.groupPerchaseOrder !=
                this.$route.params.orderId)
          ) {
            // this.orderDetails.forEach(order =>{
            //   if(order.orderState === "CONFIRMED" || order.orderState == "PAYMENT_SUCCESSFUL"){
            //     order.subOrderDTOList.forEach(list=>{
            //      let productDetail = {
            //       productName: list.itemName,
            //       imageUrl : list.itemImage,
            //       mrp: list.mrp,
            //       sellingPrice: list.totalPaidAmount,
            //       productUrl: `https://localui.mall91.com/#/detail/${list.sellerItemRelationShipId}?source=PINCODE_GLOBAL_CHANNEL`,
            //       userImageUrl: this.$store.state.userInfo.profileImageUrl,
            //       buttonName: this.$t('buyNow')
            //     }
            //     // console.log(JSON.stringify(productDetail))
            //     const obj = {
            //       message: `${replcePhoneWithAsterik(order.userDTO.name)} ने ${list.itemName} खरीद पूरी की है`,
            //       other: JSON.stringify(productDetail)
            //     }
            //     try {
            //       JSBridgePlugin.messageSCPincodeGlobalChannel(JSON.stringify(obj));
            //     } catch (err) {
            //       console.log(err);
            //     }
            //   })
            //   }
            // })
            // if(this.$cookie.get('version-code')){
            //       try{
            //         this.basketId = JSBridgePlugin.getBasketGroupId()
            //         }catch (err){
            //           console.log(err)
            //         }
            //         if(this.basketId != null){
            //           const obj = {
            //             masterOrderId:this.$route.params.orderId,
            //             basketGroupId: this.basketId
            //           }
            //           ApiCaller(constant.BASKET_GROUP_SERVICE, "join-basket-shopping-group", "post",obj).then(data => {
            //               this.shareBasketList = data.data;
            //               if(data.data[0] && data.data[0].cashBackPercentage){
            //                this.cashBackAmount = data.data[0].cashBackPercentage
            //                if(this.cashBackAmount){
            //                   setTimeout(() => {
            //                     this.showCashBackPopUp = true
            //                   },8000);
            //                }
            //              }
            //           })
            //         }else{
            //           const obj = {
            //             masterOrderId: this.$route.params.orderId
            //           }
            //           ApiCaller(constant.BASKET_GROUP_SERVICE, "join-basket-shopping-group", "post",obj).then(data => {
            //             this.shareBasketList = data.data;
            //              if(data.data[0] && data.data[0].cashBackPercentage){
            //                this.cashBackAmount = data.data[0].cashBackPercentage
            //                if(this.cashBackAmount){
            //                   setTimeout(() => {
            //                     this.showCashBackPopUp = true
            //                   },8000);
            //                }
            //              }
            //           })
            //         }
            //     }
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    goToGroup(id) {
      try {
        JSBridgePlugin.joinMall91Group(id);
        // clevertap.event.push("JOIN_GROUP");
        try {
          JSBridgePlugin.fireEvents("JOIN_GROUP");
        } catch (err) {
          console.log(err);
        }
      } catch (err) {
        console.log(err);
      }
    },
    shareFunc(itemId, subOrderId, shareImage) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          JSBridgePlugin.fireEvents("Order_Success_Product_Shared");
        } catch (err) {
          console.log(err);
        }
        this.loading = true;
        ApiCaller(
          constant.LOCAL_SHOP_URL,
          `get-share-details/${"1"}?type=order&referenceId=${subOrderId}`,
          "get"
        )
          .then((data) => {
            this.loading = false;
            const obj = {
              message: data.data.shareMessage,
              imageUrl: shareImage,
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + data.data.shareMessage);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
  },
  mounted() {
    // if (this.$route.params.orderId) {
    //   // this.getOrdersByOrderId();
    console.log(this.$store.getters.orderPurchaseData);
    if (this.$store.getters.orderPurchaseData) {
      this.orderDetails = this.$store.getters.orderPurchaseData;
    } else {
      this.getOrdersByOrderMasterId();
    }
  },
};
</script>
<style lang="scss" scoped>
.share-basket {
  background: green;
  color: #fff;
  padding: 6px 30px 4px;
  line-height: 1;
  border-radius: 15px;
  display: block;
  width: max-content;
  margin: 4px auto 8px;
}
.order_confirmation {
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  &.success {
    img {
      width: 50%;
      display: block;
      margin: 0 auto 0;
    }
  }
  .congratsText {
    font-size: 1.5em;
    margin-bottom: 0.75em;
    font-weight: 700;
    color: #138808;
    display: block;
  }
  .got_order {
    font-size: 1.05em;
    margin: 5px 0;
    font-weight: 700;
    display: block;
  }
}
.page-status-panel {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .img-block {
    width: 100%;
    height: 200px;
    margin-top: 25px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .bg_stars {
    background-image: url("../../assets/images/icons/star_ptrn.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .details-block {
    width: 100%;
    padding: 15px;
    align-self: flex-end;
    h2 {
      color: #262626;
      font-size: 1.25em;
      text-align: center;
      padding: 15px 0px 20px;
    }
    p {
      color: #999;
      font-size: 1em;
      line-height: 28px;
      text-align: center;
    }
  }
}
.btn-block {
  width: 100%;
  text-align: center;
  span {
    &.money-transfer {
      background: #ff9933;
      padding: 10px 35px;
      font-size: 1em;
      color: #fff;
      border-radius: 9px;
      display: block;
      width: max-content;
      margin: 0 auto 15px;
    }
    &.gotohome {
      color: #ff9933;
    }
  }
  .success {
    background: #138808;
  }
}
.group-exist {
  padding: 0 15px;
  font-weight: 600;
  .complete-group {
    color: #666;
    font-size: 0.875em;
  }
  .share-message {
    font-size: 0.938em;
    color: #ff9933;
    margin: 12px 0;
  }
  .group-button {
    display: block;
    background: #cccccc6b;
    padding: 10px;
    width: fit-content;
    margin: 0 auto;
    border-radius: 10px;
    .share-count {
      font-size: 0.875em;
      // margin-bottom: 8px;
      color: #555;
      line-height: 1;
    }
  }
  .button-field {
    display: flex;
    margin-top: 16px;
    width: 100%;
    justify-content: space-evenly;
    .go-to-shopping {
      // border: 1px solid #ff9933;
      color: #fff;
      padding: 5px 2px;
      border-radius: 8px;
      display: block;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
      // margin: 0 auto;
      width: 40%;
      color: #fff;
      background: #ff9933;
      font-size: 1.05em;
    }
  }
  .go-to-listing {
    display: block;
    font-size: 0.75em;
    color: #73a4f3;
    padding-bottom: 2px;
    border-bottom: 1px solid;
    width: fit-content;
    margin: 20px auto 0;
  }
}
.cart_order_confirmation {
  height: calc(100vh - 68px);
  background: #f4f6f8;
  .success {
    width: 30%;
    display: block;
    margin: 0 auto;
  }

  .cart-item-card {
    background-color: #f4f6f8;
    padding-bottom: 68px;
    .main-wrapper {
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.22);
      background: #fff;
      border-radius: 5px;
      .product-card {
        // padding-bottom: 0;
        // padding-right: 0;
        border-radius: 5px;
      }
      .complete-group {
        font-size: 0.75em;
        padding: 0 15px 8px;
        color: #0f6cd5;
        font-weight: 600;
      }
      .share-option {
        width: 100%;
        span {
          display: block;
          width: 50%;
          text-align: center;
          color: #fff;
          padding: 6px;
          font-size: 0.875em;
          &.share-button {
            background: #138808;
            // border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            &.nogroup {
              width: 100%;
              border-bottom-right-radius: 5px;
            }
          }
          &.group-button {
            background: #ff9933;
            // border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }
      }
    }
  }
  .congratsText {
    font-size: 1.05em;
    margin-bottom: 0.75em;
    font-weight: 700;
    // color: #138808;
    display: block;
  }
  .got_order {
    font-size: 0.875em;
    color: #727272;
    margin: 5px 0;
    display: block;
  }
  .upper-part {
    background: #fff;
    padding: 25px 40px;
    text-align: center;
  }

  .go-to-order-page {
    padding: 25px;
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    background: #f4f6f8;
    color: #0e6cd5;
    font-weight: 600;
    font-size: 0.938em;
  }
}
</style>
